import React from 'react';
import EvidenceTab from 'Common/Components/EvidenceTab';
import CommentTab from '../CommentTab';
import CustomFieldsTab from '../CustomFieldsTab';
import TechnicalTab from '../TechnicalTab';
import GeneralTab from '../GeneralTab';
import CredentialsTab from '../CredentialsTab';
import StatusTraceTab from '../StatusTraceTab';

const TABS_CONTEXT = [
  {
    id: 'general',
    intlId: 'manage.detail.tab.general',
    component: <GeneralTab />
  },
  {
    id: 'technicalDetails',
    intlId: 'manage.detail.tab.technicalDetails',
    component: <TechnicalTab />
  },
  {
    id: 'evidence',
    intlId: 'manage.detail.tab.evidence',
    component: <EvidenceTab />
  },
  {
    id: 'customFields',
    intlId: 'manage.detail.tab.customAttributes',
    component: <CustomFieldsTab />
  },
  {
    id: 'comment',
    intlId: 'manage.detail.tab.comment',
    component: <CommentTab />
  },
  {
    id: 'credentials',
    intlId: 'manage.detail.tab.credentials',
    component: <CredentialsTab />
  },
  {
    id: 'statusTrace',
    intlId: 'manage.detail.tab.statusTrace',
    component: <StatusTraceTab entity="manage.vulnDetail" />
  }
];

export default TABS_CONTEXT;
